import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import RegisterPage from "@/pages/RegisterPage";
import ActivitiesPage from "@/pages/ActivitiesPage";
import PlanVisitPage from "@/pages/PlanVisitPage";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    const badge = document.getElementById("emergent-badge");
    if (badge) badge.remove();
    const observer = new MutationObserver(() => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);
  return (
    <div className="min-h-screen flex flex-col bg-paper">
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/activities" element={<ActivitiesPage />} />
            <Route path="/plan-your-visit" element={<PlanVisitPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
